var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32pt",
    height: "32pt",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 2.207031 1.9375 C 1.855469 2.128906 1.839844 2.367188 2.175781 2.734375 C 2.414062 2.992188 2.449219 2.992188 2.753906 2.6875 C 3.070312 2.367188 3.070312 2.351562 2.785156 2.0625 C 2.558594 1.855469 2.414062 1.824219 2.207031 1.9375 Z M 2.207031 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 6.015625 2.0625 C 5.742188 2.351562 5.742188 2.382812 6.0625 2.703125 L 6.398438 3.039062 L 6.734375 2.703125 C 7.054688 2.382812 7.054688 2.351562 6.785156 2.0625 C 6.640625 1.902344 6.464844 1.761719 6.398438 1.761719 C 6.335938 1.761719 6.160156 1.902344 6.015625 2.0625 Z M 6.015625 2.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.785156 2.097656 C 10.527344 2.382812 10.527344 2.414062 10.785156 2.703125 C 11.039062 2.992188 11.089844 2.992188 11.375 2.753906 C 11.761719 2.414062 11.761719 2.207031 11.375 1.96875 C 11.121094 1.808594 11.023438 1.839844 10.785156 2.097656 Z M 10.785156 2.097656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 20.113281 2.078125 C 19.824219 2.367188 19.824219 2.382812 20.160156 2.71875 L 20.511719 3.070312 L 20.847656 2.734375 C 21.167969 2.414062 21.167969 2.398438 20.878906 2.078125 C 20.527344 1.695312 20.480469 1.695312 20.113281 2.078125 Z M 20.113281 2.078125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 24.863281 2.097656 C 24.59375 2.398438 24.59375 2.414062 24.894531 2.734375 C 25.214844 3.039062 25.214844 3.039062 25.566406 2.671875 L 25.9375 2.289062 L 25.550781 2.03125 C 25.183594 1.792969 25.136719 1.792969 24.863281 2.097656 Z M 24.863281 2.097656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 28.878906 2.078125 C 28.609375 2.382812 28.609375 2.414062 28.878906 2.71875 C 29.136719 3.007812 29.167969 3.007812 29.535156 2.753906 C 30 2.414062 30.015625 2.335938 29.535156 2.03125 C 29.183594 1.792969 29.136719 1.792969 28.878906 2.078125 Z M 28.878906 2.078125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 15.425781 2.144531 C 15.121094 2.382812 15.121094 2.382812 15.441406 2.625 C 15.617188 2.753906 15.808594 2.878906 15.855469 2.878906 C 16.078125 2.878906 16.351562 2.398438 16.257812 2.160156 C 16.144531 1.855469 15.824219 1.855469 15.425781 2.144531 Z M 15.425781 2.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 6 5.519531 C 5.648438 5.726562 5.328125 6 5.3125 6.160156 C 5.230469 6.511719 6.0625 7.695312 6.304688 7.566406 C 6.398438 7.503906 6.753906 7.296875 7.089844 7.089844 L 7.695312 6.703125 L 7.34375 6.113281 C 6.769531 5.136719 6.71875 5.121094 6 5.519531 Z M 6 5.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.6875 5.566406 C 10.257812 5.808594 9.921875 6.0625 9.921875 6.144531 C 9.921875 6.238281 10.113281 6.59375 10.351562 6.945312 C 10.59375 7.3125 10.800781 7.617188 10.816406 7.648438 C 10.832031 7.679688 11.105469 7.519531 11.425781 7.296875 C 11.742188 7.089844 12.097656 6.878906 12.191406 6.847656 C 12.289062 6.816406 12.191406 6.464844 11.921875 5.953125 C 11.679688 5.488281 11.472656 5.121094 11.457031 5.121094 C 11.457031 5.121094 11.105469 5.328125 10.6875 5.566406 Z M 10.6875 5.566406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 15.441406 5.503906 C 15.105469 5.710938 14.785156 5.96875 14.753906 6.078125 C 14.703125 6.222656 15.183594 7.3125 15.457031 7.664062 C 15.488281 7.695312 15.710938 7.566406 15.96875 7.375 C 16.238281 7.183594 16.527344 7.039062 16.625 7.039062 C 17.007812 7.039062 16.976562 6.558594 16.558594 5.855469 C 16.320312 5.457031 16.113281 5.121094 16.113281 5.136719 C 16.097656 5.136719 15.792969 5.3125 15.441406 5.503906 Z M 15.441406 5.503906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 24.800781 5.566406 C 24.398438 5.777344 24.046875 5.984375 24.03125 6.015625 C 24 6.03125 24.160156 6.414062 24.414062 6.863281 C 24.816406 7.632812 24.878906 7.664062 25.183594 7.472656 C 25.375 7.34375 25.761719 7.121094 26.046875 6.976562 L 26.574219 6.703125 L 26.238281 6.257812 C 26.0625 6 25.921875 5.726562 25.921875 5.632812 C 25.921875 5.199219 25.488281 5.183594 24.800781 5.566406 Z M 24.800781 5.566406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 19.96875 5.632812 C 19.632812 5.824219 19.359375 6.03125 19.359375 6.097656 C 19.359375 6.144531 19.550781 6.527344 19.777344 6.945312 C 20.03125 7.390625 20.257812 7.632812 20.367188 7.566406 C 20.480469 7.503906 20.832031 7.296875 21.152344 7.105469 L 21.742188 6.734375 L 21.375 6.046875 C 21.183594 5.664062 20.910156 5.34375 20.785156 5.328125 C 20.65625 5.296875 20.289062 5.441406 19.96875 5.632812 Z M 19.96875 5.632812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 2.097656 6.0625 C 1.761719 6.398438 1.761719 6.414062 2.0625 6.734375 L 2.367188 7.070312 L 2.71875 6.71875 C 3.070312 6.367188 3.070312 6.367188 2.753906 6.046875 L 2.433594 5.726562 Z M 2.097656 6.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 28.878906 6.078125 C 28.59375 6.398438 28.59375 6.414062 28.894531 6.71875 C 29.183594 7.007812 29.214844 7.007812 29.550781 6.734375 L 29.902344 6.449219 L 29.535156 6.097656 L 29.167969 5.761719 Z M 28.878906 6.078125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.207031 9.726562 C 9.632812 9.921875 9.441406 10.0625 9.441406 10.289062 C 9.441406 10.832031 9.96875 12.320312 10.160156 12.320312 C 10.382812 12.320312 12.207031 11.839844 12.289062 11.761719 C 12.335938 11.726562 12.238281 11.183594 12.078125 10.558594 C 11.824219 9.519531 11.777344 9.441406 11.375 9.457031 C 11.152344 9.472656 10.625 9.601562 10.207031 9.726562 Z M 10.207031 9.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 15.070312 9.742188 C 14.449219 9.9375 14.257812 10.0625 14.335938 10.238281 C 14.382812 10.367188 14.496094 10.800781 14.59375 11.199219 C 14.6875 11.601562 14.785156 12.015625 14.816406 12.144531 C 14.878906 12.367188 15.488281 12.320312 16.6875 11.96875 C 17.375 11.761719 17.359375 11.839844 16.960938 10.191406 C 16.800781 9.519531 16.734375 9.441406 16.351562 9.457031 C 16.113281 9.472656 15.535156 9.601562 15.070312 9.742188 Z M 15.070312 9.742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 20.078125 9.726562 C 19.648438 9.871094 19.246094 10 19.214844 10.03125 C 19.089844 10.128906 19.886719 12.320312 20.0625 12.320312 C 20.304688 12.320312 22.128906 11.839844 22.207031 11.761719 C 22.238281 11.726562 22.144531 11.199219 22 10.574219 C 21.742188 9.519531 21.679688 9.441406 21.296875 9.457031 C 21.070312 9.457031 20.527344 9.585938 20.078125 9.726562 Z M 20.078125 9.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 6.414062 10.03125 C 6.289062 10.078125 5.953125 10.289062 5.664062 10.480469 L 5.136719 10.832031 L 5.601562 11.585938 L 6.078125 12.320312 L 6.878906 11.902344 C 7.3125 11.679688 7.679688 11.457031 7.679688 11.40625 C 7.679688 11.359375 7.550781 11.136719 7.390625 10.910156 C 7.230469 10.671875 7.039062 10.351562 6.992188 10.191406 C 6.878906 9.902344 6.800781 9.886719 6.414062 10.03125 Z M 6.414062 10.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 24.753906 10.304688 C 24.433594 10.496094 24.128906 10.703125 24.078125 10.753906 C 23.984375 10.847656 24.257812 11.390625 24.65625 11.96875 L 24.929688 12.351562 L 25.742188 11.886719 C 26.222656 11.601562 26.496094 11.359375 26.414062 11.265625 C 26.335938 11.183594 26.128906 10.878906 25.96875 10.574219 C 25.808594 10.273438 25.601562 10 25.519531 9.984375 C 25.425781 9.953125 25.089844 10.097656 24.753906 10.304688 Z M 24.753906 10.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 2.015625 10.847656 C 1.777344 11.136719 1.777344 11.167969 2.078125 11.441406 C 2.382812 11.710938 2.414062 11.710938 2.71875 11.441406 C 3.023438 11.167969 3.023438 11.136719 2.785156 10.847656 C 2.625 10.6875 2.464844 10.558594 2.398438 10.558594 C 2.335938 10.558594 2.175781 10.6875 2.015625 10.847656 Z M 2.015625 10.847656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 28.910156 10.832031 C 28.703125 11.070312 28.703125 11.167969 28.863281 11.390625 C 29.136719 11.761719 29.214844 11.742188 29.585938 11.375 C 29.871094 11.089844 29.886719 11.054688 29.617188 10.816406 C 29.265625 10.496094 29.230469 10.496094 28.910156 10.832031 Z M 28.910156 10.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 13.921875 15.839844 L 13.921875 17.761719 L 17.761719 17.761719 L 17.761719 13.921875 L 13.921875 13.921875 Z M 13.921875 15.839844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 21.28125 14.398438 C 21.152344 14.464844 20.625 14.609375 20.128906 14.71875 C 19.617188 14.816406 19.199219 14.945312 19.199219 14.992188 C 19.199219 15.039062 19.359375 15.566406 19.535156 16.191406 C 19.855469 17.246094 19.902344 17.3125 20.304688 17.230469 C 20.753906 17.136719 22.128906 16.769531 22.207031 16.71875 C 22.273438 16.671875 21.742188 14.480469 21.632812 14.367188 C 21.566406 14.304688 21.40625 14.320312 21.28125 14.398438 Z M 21.28125 14.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.800781 14.558594 C 10.542969 14.625 10.128906 14.734375 9.886719 14.785156 C 9.566406 14.863281 9.441406 14.992188 9.441406 15.230469 C 9.441406 15.824219 9.96875 17.28125 10.191406 17.28125 C 10.304688 17.28125 10.847656 17.152344 11.375 17.007812 L 12.351562 16.734375 L 12.238281 16.175781 C 11.921875 14.414062 11.808594 14.289062 10.800781 14.558594 Z M 10.800781 14.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 24.878906 14.960938 C 24.527344 15.183594 24.175781 15.375 24.097656 15.40625 C 23.902344 15.472656 24.59375 16.800781 24.878906 16.894531 C 25.007812 16.960938 25.425781 16.800781 25.808594 16.542969 L 26.511719 16.113281 L 26.175781 15.601562 C 25.984375 15.3125 25.777344 14.960938 25.679688 14.832031 C 25.535156 14.59375 25.457031 14.609375 24.878906 14.960938 Z M 24.878906 14.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 5.726562 15.121094 L 5.136719 15.519531 L 5.550781 16.257812 C 5.902344 16.894531 6.015625 16.976562 6.351562 16.878906 C 6.574219 16.832031 6.945312 16.640625 7.199219 16.464844 L 7.648438 16.128906 L 7.246094 15.425781 C 6.800781 14.625 6.574219 14.574219 5.726562 15.121094 Z M 5.726562 15.121094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 2.078125 15.535156 C 1.742188 16.160156 2.273438 16.625 2.703125 16.097656 C 2.847656 15.921875 2.847656 15.792969 2.6875 15.535156 C 2.433594 15.121094 2.304688 15.121094 2.078125 15.535156 Z M 2.078125 15.535156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 28.878906 15.503906 C 28.65625 15.777344 28.640625 15.871094 28.800781 16.078125 C 29.054688 16.382812 29.34375 16.382812 29.601562 16.0625 C 29.777344 15.871094 29.761719 15.777344 29.503906 15.503906 C 29.183594 15.183594 29.183594 15.183594 28.878906 15.503906 Z M 28.878906 15.503906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.199219 19.359375 C 11.070312 19.441406 10.59375 19.601562 10.144531 19.695312 C 9.328125 19.871094 9.328125 19.886719 9.441406 20.382812 C 9.679688 21.441406 9.984375 22.238281 10.113281 22.238281 C 10.191406 22.238281 10.71875 22.128906 11.28125 21.984375 C 11.96875 21.808594 12.320312 21.648438 12.320312 21.488281 C 12.320312 20.976562 11.761719 19.199219 11.601562 19.199219 C 11.519531 19.199219 11.328125 19.28125 11.199219 19.359375 Z M 11.199219 19.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 16.160156 19.34375 C 16.03125 19.425781 15.535156 19.566406 15.070312 19.679688 C 14.382812 19.839844 14.238281 19.921875 14.335938 20.144531 C 14.382812 20.289062 14.527344 20.785156 14.65625 21.246094 C 14.769531 21.726562 14.894531 22.144531 14.945312 22.191406 C 14.992188 22.238281 15.535156 22.160156 16.160156 22 C 17.457031 21.679688 17.390625 21.824219 16.945312 20.03125 C 16.71875 19.199219 16.609375 19.089844 16.160156 19.34375 Z M 16.160156 19.34375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 20.320312 19.550781 C 19.742188 19.742188 19.265625 19.902344 19.230469 19.921875 C 19.199219 19.953125 19.34375 20.480469 19.535156 21.121094 C 19.839844 22.144531 19.921875 22.257812 20.222656 22.175781 C 20.414062 22.128906 20.945312 22.015625 21.40625 21.921875 C 21.855469 21.808594 22.238281 21.648438 22.222656 21.550781 C 22.175781 20.976562 21.664062 19.296875 21.519531 19.265625 C 21.441406 19.246094 20.894531 19.375 20.320312 19.550781 Z M 20.320312 19.550781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 25.121094 19.519531 C 24.894531 19.695312 24.640625 19.839844 24.542969 19.839844 C 24.113281 19.839844 24 20.257812 24.289062 20.734375 C 24.929688 21.855469 24.816406 21.808594 25.710938 21.3125 L 26.542969 20.863281 L 26.03125 20.046875 L 25.519531 19.214844 Z M 25.121094 19.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 5.886719 19.761719 L 5.136719 20.160156 L 5.566406 20.960938 C 5.984375 21.726562 6.273438 21.9375 6.480469 21.601562 C 6.527344 21.519531 6.816406 21.328125 7.121094 21.183594 L 7.664062 20.929688 L 7.230469 20.144531 C 6.992188 19.710938 6.769531 19.359375 6.71875 19.375 C 6.671875 19.375 6.304688 19.550781 5.886719 19.761719 Z M 5.886719 19.761719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 2.097656 20.222656 L 1.761719 20.59375 L 2.078125 20.878906 C 2.398438 21.167969 2.414062 21.167969 2.734375 20.847656 L 3.070312 20.511719 L 2.753906 20.191406 L 2.433594 19.871094 Z M 2.097656 20.222656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 28.847656 20.304688 C 28.703125 20.527344 28.71875 20.640625 28.910156 20.847656 C 29.136719 21.070312 29.199219 21.070312 29.550781 20.847656 C 29.902344 20.609375 29.921875 20.574219 29.664062 20.304688 C 29.3125 19.921875 29.089844 19.921875 28.847656 20.304688 Z M 28.847656 20.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 5.9375 24.433594 C 5.34375 24.785156 5.265625 24.894531 5.359375 25.230469 C 5.40625 25.457031 5.601562 25.839844 5.792969 26.097656 C 6.113281 26.527344 6.144531 26.542969 6.558594 26.304688 C 6.785156 26.160156 7.136719 25.921875 7.34375 25.777344 L 7.695312 25.503906 L 7.375 25.089844 C 7.183594 24.863281 7.039062 24.59375 7.039062 24.511719 C 7.039062 24.433594 6.945312 24.289062 6.832031 24.191406 C 6.6875 24.0625 6.449219 24.128906 5.9375 24.433594 Z M 5.9375 24.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.609375 24.449219 C 10.222656 24.6875 9.921875 24.929688 9.921875 25.007812 C 9.921875 25.070312 10.113281 25.425781 10.351562 25.808594 C 10.59375 26.175781 10.800781 26.496094 10.816406 26.527344 C 10.832031 26.558594 11.167969 26.351562 11.566406 26.078125 C 12.113281 25.710938 12.273438 25.519531 12.207031 25.3125 C 12.03125 24.847656 11.488281 24 11.390625 24.015625 C 11.328125 24.015625 10.976562 24.222656 10.609375 24.449219 Z M 10.609375 24.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 15.390625 24.433594 C 15.023438 24.671875 14.71875 24.960938 14.71875 25.070312 C 14.71875 25.214844 15.214844 26.191406 15.457031 26.542969 C 15.488281 26.574219 15.710938 26.449219 15.96875 26.257812 C 16.238281 26.0625 16.527344 25.921875 16.625 25.921875 C 17.007812 25.921875 16.976562 25.441406 16.558594 24.734375 C 16.320312 24.335938 16.113281 24 16.097656 24 C 16.078125 24 15.761719 24.191406 15.390625 24.433594 Z M 15.390625 24.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 20.480469 24.207031 C 20.257812 24.335938 19.871094 24.542969 19.632812 24.703125 C 19.246094 24.976562 19.214844 25.039062 19.40625 25.265625 C 19.535156 25.40625 19.761719 25.761719 19.902344 26.046875 C 20.191406 26.609375 20.078125 26.625 21.3125 25.871094 L 21.742188 25.601562 L 21.328125 24.847656 C 21.105469 24.414062 20.910156 24.0625 20.894531 24.046875 C 20.878906 24.03125 20.6875 24.097656 20.480469 24.207031 Z M 20.480469 24.207031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 24.800781 24.414062 C 24.398438 24.640625 24.046875 24.847656 24.015625 24.878906 C 23.96875 24.929688 24.703125 26.304688 24.894531 26.542969 C 24.929688 26.574219 25.089844 26.496094 25.230469 26.367188 C 25.390625 26.222656 25.742188 26 26.03125 25.855469 L 26.542969 25.601562 L 26.046875 24.800781 C 25.777344 24.351562 25.550781 24 25.535156 24 C 25.519531 24 25.199219 24.191406 24.800781 24.414062 Z M 24.800781 24.414062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 2.160156 24.863281 C 1.886719 25.054688 1.871094 25.152344 2.046875 25.503906 C 2.273438 26.015625 2.398438 26.015625 2.753906 25.535156 C 3.007812 25.183594 3.007812 25.136719 2.734375 24.894531 C 2.496094 24.671875 2.414062 24.671875 2.160156 24.863281 Z M 2.160156 24.863281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 28.929688 24.910156 C 28.6875 25.183594 28.6875 25.230469 28.945312 25.566406 L 29.214844 25.9375 L 29.519531 25.601562 C 29.808594 25.28125 29.808594 25.265625 29.503906 24.945312 C 29.199219 24.640625 29.167969 24.640625 28.929688 24.910156 Z M 28.929688 24.910156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 2.175781 28.945312 C 1.953125 29.183594 1.9375 29.328125 2.078125 29.585938 C 2.304688 30 2.414062 30 2.785156 29.585938 C 3.054688 29.246094 3.054688 29.230469 2.769531 28.929688 C 2.464844 28.640625 2.449219 28.640625 2.175781 28.945312 Z M 2.175781 28.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 6.175781 28.878906 C 5.921875 29.070312 5.886719 29.183594 6.046875 29.519531 C 6.273438 30.015625 6.398438 30.015625 6.785156 29.585938 C 7.054688 29.246094 7.054688 29.230469 6.769531 28.945312 C 6.511719 28.6875 6.449219 28.6875 6.175781 28.878906 Z M 6.175781 28.878906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.71875 29.039062 C 10.558594 29.246094 10.574219 29.34375 10.800781 29.617188 L 11.105469 29.9375 L 11.425781 29.601562 C 11.761719 29.265625 11.761719 29.265625 11.457031 29.023438 C 11.054688 28.734375 10.960938 28.734375 10.71875 29.039062 Z M 10.71875 29.039062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 15.441406 29.007812 C 15.167969 29.214844 15.167969 29.246094 15.488281 29.566406 C 15.921875 30 15.953125 30 16.160156 29.585938 C 16.304688 29.34375 16.289062 29.199219 16.144531 29.023438 C 15.921875 28.753906 15.824219 28.734375 15.441406 29.007812 Z M 15.441406 29.007812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 20.175781 29.023438 C 20.03125 29.199219 20.03125 29.328125 20.191406 29.585938 C 20.449219 30 20.574219 30 20.800781 29.585938 C 21.136719 28.960938 20.609375 28.496094 20.175781 29.023438 Z M 20.175781 29.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 24.863281 29.023438 C 24.816406 29.152344 24.863281 29.40625 24.960938 29.601562 L 25.152344 29.953125 L 25.488281 29.632812 C 25.761719 29.359375 25.777344 29.265625 25.601562 29.054688 C 25.34375 28.734375 24.976562 28.71875 24.863281 29.023438 Z M 24.863281 29.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 28.863281 29.023438 C 28.816406 29.152344 28.863281 29.40625 28.960938 29.601562 L 29.152344 29.953125 L 29.488281 29.632812 C 29.761719 29.359375 29.777344 29.265625 29.601562 29.054688 C 29.34375 28.734375 28.976562 28.71875 28.863281 29.023438 Z M 28.863281 29.023438 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1ea1a181.svg";
export { ForwardRef as ReactComponent };